const STATE_SELECTOR = "[data-filter-hydration-state-value]"

export const FILTERS_HYDRATED_EVENT = "filters:hydrated"

export function filterState() {
  const element = document.querySelector(STATE_SELECTOR)
  if (!element) return null

  try {
    return JSON.parse(element.dataset.filterHydrationStateValue)
  } catch {
    return null
  }
}

export function applyFilterState(form, state) {
  for (const [name, values] of Object.entries(state.checked ?? {})) {
    inputsNamed(form, name).forEach((input) => {
      if (isToggle(input)) input.checked = values.includes(input.value)
    })
  }

  for (const [name, value] of Object.entries(state.values ?? {})) {
    inputsNamed(form, name).forEach((input) => {
      if (!isToggle(input)) input.value = value
    })
  }
}

function inputsNamed(form, name) {
  return Array.from(form.querySelectorAll(`[name="${name}"]`))
}

function isToggle(input) {
  return input.type === "checkbox" || input.type === "radio"
}
